export default "__VITE_ASSET__7f2a0452__"